import { render, staticRenderFns } from "./BlockContact.vue?vue&type=template&id=c13e690e&"
import script from "./BlockContact.vue?vue&type=script&lang=js&"
export * from "./BlockContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports